import { render, staticRenderFns } from "./FeaturesTabs.vue?vue&type=template&id=c84e1314"
import script from "./FeaturesTabs.vue?vue&type=script&lang=js"
export * from "./FeaturesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FeatureTag: require('/opt/build/repo/components/FeatureTag.vue').default})
